import React, {ChangeEvent, useEffect, useState} from 'react';
import { IProps } from 'components/BaseModalComponents/BasedModal'
import BasedModal from 'components/BaseModalComponents/BasedModal';
import ModalHeader from "components/BaseModalComponents/Header/ModalHeader";
import ModalFooter from "components/BaseModalComponents/Footer/ModalFooter";
import {
    Container,
    ModalBody,
    TextArea
} from "./formulaModalStyles";

function FormulaModal({isOpen, title, onRequestClose, onApplyClick, value} : IProps) {
    const [formula, setFormula] = useState<string>('');
    const handleChangeFormula = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setFormula(e.target.value);
    }

    const handleOnClick = () => {
        if ((typeof formula === 'string' && formula.length) || typeof value === 'string' && value.length) {
            onApplyClick(formula);
            if (typeof onRequestClose === 'function') {
                //@ts-ignore
                onRequestClose();
            }
        }
    }
    useEffect(() => {
        setFormula(value);
    }, [value]);
    return (
        <BasedModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
        >
            <Container>
                <ModalHeader>
                    <div>{title}</div>
                </ModalHeader>
                <ModalBody>
                    <TextArea
                        placeholder="Ввести формулу"
                        onChange={handleChangeFormula}
                        value={ formula }
                    />
                </ModalBody>
                <ModalFooter
                    applyText="Применить" onApplyClick={handleOnClick}
                    cancelText="Отменить" onCancelClick={onRequestClose}
                />
            </Container>
        </BasedModal>
    );
}

export default FormulaModal;
